import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { useShipmentNoteFeed } from '#/entities/shipment'
import type { ShipmentNoteFeedItem } from '#/entities/shipment'
import { HistoryAppTag, HistoryRating, NoteRow } from '#/shared/ui/history-row'
import { RichText } from '#/shared/ui/rich-text'

import { GroupedItems } from './grouped-items'

function noteMeta(note: ShipmentNoteFeedItem): ReactNode[] {
  const meta: ReactNode[] = [note.timestamp]
  if (note.isApp) meta.push(<HistoryAppTag />)
  else if (note.author) meta.push(note.author)
  if (note.rating) meta.push(<HistoryRating value={note.rating} />)
  return meta
}

function NoteListRow({ note }: { note: ShipmentNoteFeedItem }) {
  return (
    <NoteRow
      hideIcon
      title={<RichText html={note.text} />}
      meta={noteMeta(note)}
    />
  )
}

export function ExistingNotes({
  shipmentId,
}: {
  shipmentId: string | undefined
}) {
  const { t } = useTranslation()
  const { notes, isLoading } = useShipmentNoteFeed(shipmentId ?? '', {
    enabled: Boolean(shipmentId),
  })

  if (isLoading || notes.length === 0) return null

  return (
    <GroupedItems
      className="px-2.5 pb-2.5"
      title={t('detailSidebar.notes.existing')}
      toggleLabel={t('detailSidebar.notes.toggleGroup')}
      items={notes}
      getKey={(note) => note.id}
      renderItem={(note) => <NoteListRow note={note} />}
      moreLabel={(count) => t('detailSidebar.notes.moreNotes', { count })}
      showMoreLabel={(count) => t('detailSidebar.notes.showMore', { count })}
    />
  )
}
